import React from 'react'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import ConfirmDialog from '../../components/ConfirmDialog'
import {
  selectClearPendingCreativeChangesConfirmDialog,
  setClearPendingCreativeChangesConfirmDialog,
  setCreativeDrawerOpen,
} from '../../state/appSlice'

export interface ClearPendingCreativeChangesConfirmDialogProps {
  open: boolean
}

const ClearPendingCreativeChangesConfirmDialog = (
  props: ClearPendingCreativeChangesConfirmDialogProps
) => {
  const dispatch = useAppDispatch()

  const confirm = () => {
    dispatch(setClearPendingCreativeChangesConfirmDialog({ open: false }))
    dispatch(setCreativeDrawerOpen(false))
  }

  const close = () =>
    dispatch(setClearPendingCreativeChangesConfirmDialog({ open: false }))

  return (
    <>
      <ConfirmDialog
        {...props}
        confirm={confirm}
        close={close}
        disableActions={false}
        body="You have unsaved changes. Are you sure that you would like to clear the changes to your ad?"
        confirmText="Clear"
        title="Clear unsaved changes?"
      />
    </>
  )
}

export default ClearPendingCreativeChangesConfirmDialog

export const ClearPendingCreativeChangesConfirmDialogContainer = () => {
  const data = useAppSelector(selectClearPendingCreativeChangesConfirmDialog)
  if (!data.open) {
    return <></>
  }
  return <ClearPendingCreativeChangesConfirmDialog {...data} />
}
